import { getCryptocurrencyApi, updateCryptocurrencyApi, addCryptocurrencyApi, getContractDetailsApi } from "../components/constant/Api";
import { myApi } from "./api";

export const userApi = myApi.injectEndpoints({
    endpoints: (builder) => ({

        getCryptocurrency: builder.query({
            query: () => {
                return {
                    url: getCryptocurrencyApi,
                    method: "GET",
                };
            },
            transformResponse: (response, meta, arg) => {
                return response.status ? response : { data: [], total: 0 };
            },
            providesTags: (_) => ["user"],
        }),
        updateCryptocurrency: builder.mutation({
            query: (post) => ({
                url: updateCryptocurrencyApi,
                method: "POST",
                body: post
            }),
            invalidatesTags: (_) => ["user"],
        }),
        addCryptocurrency: builder.mutation({
            query: (post) => ({
                url: addCryptocurrencyApi,
                method: "POST",
                body: post
            }),
            invalidatesTags: (_) => ["user"],
        }),
        getContractDetails: builder.mutation({
            query: (post) => ({
                url: getContractDetailsApi,
                method: "POST",
                body: post
            }),
        }),

    }),
});

export const { useGetCryptocurrencyQuery, useUpdateCryptocurrencyMutation, useAddCryptocurrencyMutation, useGetContractDetailsMutation } = userApi;